import Gorilla from '../media/avatar icons/gorilla.jpg';
import Beaver from '../media/avatar icons/beaver.jpg';
import Cat from '../media/avatar icons/cat.jpg';
import Dog from '../media/avatar icons/dog.jpg';
import Koala from '../media/avatar icons/koala.jpg';
import Rabbit from '../media/avatar icons/rabbit.jpg';
import Tiger from '../media/avatar icons/tiger.jpg';
import Fox from '../media/avatar icons/fox.jpg';

const IMAGES = [
    Gorilla,
    Beaver,
    Cat,
    Dog,
    Koala,
    Rabbit,
    Tiger,
    Fox
]

export default IMAGES